import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { Modal } from "bootstrap"; // es6 module
// import nlLocale from '@fullcalendar/core/locales/es';
import allLocales from "@fullcalendar/core/locales-all";
import rrulePlugin from '@fullcalendar/rrule'

// import nl from "../fullcalendar/locales/nl.js";

document.addEventListener("DOMContentLoaded", function () {
  var calendarEl = document.getElementById("calendar");
  var modal = new Modal(document.getElementById("calendarModal"));
  var modalEl = document.getElementById("calendarModal");
  var modalTitle = document.getElementById("modalTitle");
  var modalContent = document.getElementById("modalContent");
  var modalTime = document.getElementById("modalTime");
  var modalTimeEnd = document.getElementById("modalTimeEnd");
  var modalLoonlyTimeEnd = document.getElementById("modalLoonlyTimeEnd");
  var modalTimeWrap = document.getElementById("modalTimes");
  var modalTimeStartWrap = document.getElementById("modalStartWrap");
  var modalTimeEndWrap = document.getElementById("modalTimeEndWrap");
  var modalLoonlyTimeEndWrap = document.getElementById("modalLoonlyTimeEndWrap");
  var DAY_NAMES = [
    "Zondag",
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrijdag",
    "Zaterdag",
  ];

  let calendar = new Calendar(calendarEl, {
    locales: allLocales,
    locale: "nl",

    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, rrulePlugin],
    events: "/wp-admin/admin-ajax.php?action=vzod_get_events",
    
    eventClick: function (info) {
      modal.show();
      var start = info.event.extendedProps.starttijd;
      var eind = info.event.extendedProps.eindtijd;
      var eindLoonly = info.event.extendedProps.eindtijd;
      modalTitle.innerText = info.event.title;
      modalContent.innerText = info.event.extendedProps.description;
      if (typeof start !== "undefined" && typeof eind !== "undefined") {
        modalTimeWrap.style.display = "block";
        if (typeof start !== "undefined") {
          modalTimeStartWrap.style.display = "inline-block";
          modalTime.innerText = start;
        } else if (typeof start == "undefined") {
          modalTimeStartWrap.style.display = "none";
        }
        if (typeof eind !== "undefined") {
          modalTimeEndWrap.style.display = "inline-block";
          modalTimeEnd.innerText = eind;
        } else if (typeof eind == "undefined") {
          modalTimeEndWrap.style.display = "none";
        }
      }else if (typeof start !== "undefined" || typeof eind !== "undefined") {
        modalTimeWrap.style.display = "block";
        if (typeof start !== "undefined") {
          modalTimeStartWrap.style.display = "inline-block";
          modalTime.innerText = start;
        } else if (typeof start == "undefined") {
          modalTimeStartWrap.style.display = "none";
        }
        if (typeof eindLoonly !== "undefined") {
          modalLoonlyTimeEndWrap.style.display = "inline-block";
          modalLoonlyTimeEnd.innerText = eindLoonly;
        } else if (typeof eindLoonly == "undefined") {
          modalLoonlyTimeEndWrap.style.display = "none";
        }
      }
      modalEl.addEventListener('hidden.bs.modal', function(e) {
        modalTimeWrap.style.display = "none";
        modalTimeEndWrap.style.display = "none";
        modalTimeStartWrap.style.display = "none";
        modalLoonlyTimeEndWrap.style.display = "none";
      })
    },
    // initialView: "dayGridMonth",


    headerToolbar: {
      center: "",
      right: "",
      left: "title",
    },
  
    footerToolbar: {
      center: "prev,next",
    },
    dayHeaderContent: function (arg) {
      return DAY_NAMES[arg.date.getDay()];
    },
  });
  calendar.render();
});

